export default function Council2018Entries() {
  return (
    <table id="filetable">
      {/*Start Table*/}
      <tr>
        <th>Meeting Date</th>
        <th>Minutes</th>
        <th>Agenda</th>
      </tr>
      {/*Start File*/}
      <tr>
        <td>12-27-2018</td>
        <td>
          <a href="../docs/council/minutes/2018/2018-12-27-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>12-18-2018</td>
        <td>
          <a href="../docs/council/minutes/2018/2018-12-18-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>12-17-2018</td>
        <td>
          <a href="../docs/council/minutes/2018/2018-12-17-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>11-19-2018</td>
        <td>
          <a href="../docs/council/minutes/2018/2018-11-19-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>11-13-2018</td>
        <td>
          <a href="../docs/council/minutes/2018/2018-11-13-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>10-23-2018</td>
        <td>
          <a href="../docs/council/minutes/2018/2018-10-23-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>10-15-2018</td>
        <td>
          <a href="../docs/council/minutes/2018/2018-10-15-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>10-09-2018</td>
        <td>
          <a href="../docs/council/minutes/2018/2018-10-09-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>09-17-2018</td>
        <td>
          <a href="../docs/council/minutes/2018/2018-09-17-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>09-11-2018</td>
        <td>
          <a href="../docs/council/minutes/2018/2018-09-11-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>08-20-2018</td>
        <td>
          <a href="../docs/council/minutes/2018/2018-08-20-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>08-14-2018</td>
        <td>
          <a href="../docs/council/minutes/2018/2018-08-14-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>07-16-2018</td>
        <td>
          <a href="../docs/council/minutes/2018/2018-07-16-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>07-10-2018</td>
        <td>
          <a href="../docs/council/minutes/2018/2018-07-10-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>06-18-2018</td>
        <td>
          <a href="../docs/council/minutes/2018/2018-06-18-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>05-21-2018</td>
        <td>
          <a href="../docs/council/minutes/2018/2018-05-21-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>05-08-2018</td>
        <td>
          <a href="../docs/council/minutes/2018/2018-05-08-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>04-16-2018</td>
        <td>
          <a href="../docs/council/minutes/2018/2018-04-16-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>04-10-2018</td>
        <td>
          <a href="../docs/council/minutes/2018/2018-04-10-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>03-19-2018</td>
        <td>
          <a href="../docs/council/minutes/2018/2018-03-19-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>03-13-2018</td>
        <td>
          <a href="../docs/council/minutes/2018/2018-03-13-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>02-20-2018</td>
        <td>
          <a href="../docs/council/minutes/2018/2018-02-20-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>02-13-2018</td>
        <td>
          <a href="../docs/council/minutes/2018/2018-02-13-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>01-16-2018</td>
        <td>
          <a href="../docs/council/minutes/2018/2018-01-16-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>01-09-2018</td>
        <td>
          <a href="../docs/council/minutes/2018/2018-01-09-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>01-02-2018</td>
        <td>
          <a href="../docs/council/minutes/2018/2018-01-02-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
    </table>
  );
}
